import React from "react";
import { Modal, Loading } from "seed/helpers";
import l from "components/util/l";

import FileViewer from "components/collections/table/FileViewer";
import HeaderCell from "components/collections/table/HeaderCell";
import Cell from "components/collections/table/Cell";

const TableDatagrid = ({
  flow,
  columns = [],
  rows = [],
  primaryKey = null,
  filteredData = [],
  filteredColumns = [],
  collections = [],
  collectionOptions = {},
  isReadOnly = false,
  isLoading = false,
  isFilePreviewShown = false,
  isEditingCell,
  showOptions = true,
  showFilters = true,
  showSorting = true,
  showAdd = false,
  showDelete = false,
  modifyStructure = false,
  showForm,
  tableRef,
  filters,
  sorting,
  selectedCell,
  selectedFile,
  multipleSelectedCells,
  setSelectedCell,
  setSelectedFile,
  setMultipleSelectedCells,
  setFormValue,
  setZipFieldName,
  setIsFilterModalShown,
  setIsFilePreviewShown,
  setIsOptionModalShown,
  setIsFormModalShown,
  setIsSortingModalShown,
  setFilterDefault,
  setIsEditingCell,
  setIsZipModalShown,
  onClickChangeColumn = () => { },
  onClickMoveLeftColumn = () => { },
  onClickMoveRightColumn = () => { },
  onClickDeleteColumn = () => { },
  onAddRow = () => { },
  onClickDeleteRow = () => { },
  onClickInsertRow = () => { },
  onClickCloneRow = () => { },
  onChangeRow = () => { },
  onClickCell = () => { },
  onDoubleClickCell = () => { },
  onBlurCell = () => { },
  onClickOpenColumnCreateModal = () => { },
  onClickOpenColumnEditModal = () => { },
}) => {

  return (
    <div
      id="collection-table"
      ref={tableRef}
    >

      <table className="table-hover table-sm m-0 p-0">

        <thead className="table-bordered">
          <tr>
            {
              !isReadOnly &&
              <th scope="col">
                <div className="d-flex justify-content-center align-items-center mt-2 px-2">
                  <span>
                    <input
                      type="checkbox"
                      checked={multipleSelectedCells.length == filteredData.length && filteredData.length > 0}
                      onChange={() => {
                        if (multipleSelectedCells.length == filteredData.length && filteredData.length > 0)
                          setMultipleSelectedCells([]);
                        else
                          setMultipleSelectedCells(filteredData);
                      }}
                    />
                  </span>
                </div>
              </th>
            }
            {
              columns.map((column, index) => (
                (
                  !column.internal
                  // || column.name != "_internal_id"
                ) && <>
                  <HeaderCell
                    key={`header-${column.name}-${index}`}
                    collections={collections}
                    column={column}
                    filteredColumns={filteredColumns}
                    filters={filters}
                    sorting={sorting}
                    showOptions={showOptions}
                    showFilters={showFilters}
                    showSorting={showSorting}
                    isReadOnly={isReadOnly}
                    modifyStructure={modifyStructure}
                    isActive={selectedCell && selectedCell.column === index && selectedCell.row === -1}
                    isDisableMoveLeft={primaryKey && (column.name === primaryKey || columns[index - 1]?.name === primaryKey)}
                    isDisableMoveRight={(primaryKey && column.name === primaryKey) || index === columns.length - 1}
                    setSelectedCell={setSelectedCell}
                    setIsFilterModalShown={setIsFilterModalShown}
                    setIsSortingModalShown={setIsSortingModalShown}
                    setFilterDefault={setFilterDefault}
                    setZipFieldName={setZipFieldName}
                    setIsZipModalShown={setIsZipModalShown}
                    onClickChangeColumn={(value) => onClickChangeColumn(index, value)}
                    onClickMoveLeftColumn={() => onClickMoveLeftColumn(index)}
                    onClickMoveRightColumn={() => onClickMoveRightColumn(index)}
                    onClickDeleteColumn={() => onClickDeleteColumn(index)}
                    onClickOpenColumnEditModal={() => onClickOpenColumnEditModal(column.name)}
                  />
                </>
              ))
            }

            {
              !isReadOnly && <th
                scope="col"
                className="text-center add-column"
                onClick={modifyStructure ? onClickOpenColumnCreateModal : null}
              >
                <span className="p-0 m-0 w-100 text-center">
                  {
                    modifyStructure &&
                    <div className="p-0 d-flex justify-content-center align-items-center my-1 py-0 text-center w-100">
                      <span>+</span>
                    </div>
                  }
                </span>
              </th>
            }

          </tr>
        </thead>

        <tbody className="table-bordered">
          {
            filteredData.map((row, i) => (
              <tr key={i}>
                {
                  !isReadOnly &&
                  <td className="folio-column">
                    <div className="d-flex justify-content-center align-items-center mt-2 px-2">
                      <span>
                        <input
                          type="checkbox"
                          checked={multipleSelectedCells.some((r) => r.id === row.id)}
                          onChange={() => {
                            if (multipleSelectedCells.some((r) => r.id == row.id))
                              setMultipleSelectedCells(multipleSelectedCells.filter((r) => !(r.id == row.id)));
                            else
                              setMultipleSelectedCells([...multipleSelectedCells, row]);
                          }}
                        />
                      </span>
                    </div>
                  </td>
                }
                {
                  columns.filter(
                    column => !column.internal
                    // || column.name != "_internal_id"
                  ).map((column, j) => (
                    <>
                      <Cell
                        key={`${i}-${j}`}
                        flow={flow}
                        column={column}
                        row={row}
                        value={(row?.data ?? {})[column.name]}
                        collectionOptions={collectionOptions}
                        isHighlighted={row?.modified_columns?.includes(column.name)}
                        isReadOnly={isReadOnly}
                        isActive={selectedCell && selectedCell.row === i && selectedCell.column === j}
                        isEditingCell={isEditingCell}
                        showAdd={showAdd}
                        showDelete={showDelete}
                        showOptions={showOptions}
                        showFilters={showFilters}
                        setSelectedFile={setSelectedFile}
                        onTypeEnter={(e) => {
                          if (e?.target?.value) {
                            onChangeRow(i, column.name, e.target.value, Object.assign({}, row));
                            if (i === rows.length - 1) onAddRow();
                            else onClickCell(row, i + 1, j);
                          }
                        }}
                        onClickCell={() => onClickCell(row, i, j)}
                        onDoubleClickCell={() => onDoubleClickCell()}
                        onBlurCell={(e) => onBlurCell(e)}
                        onChangeRow={(value) => onChangeRow(i, column.name, value, Object.assign({}, row))}
                        onClickInsertRow={() => onClickInsertRow(i)}
                        onClickCloneRow={() => onClickCloneRow(i)}
                        onClickDeleteRow={() => onClickDeleteRow(i)}
                        onShowOptions={() => setIsOptionModalShown(true)}
                        setSelectedCell={setSelectedCell}
                        setIsEditingCell={setIsEditingCell}
                        setIsFilterModalShown={setIsFilterModalShown}
                        setFilterDefault={setFilterDefault}
                      />
                    </>
                  ))
                }

                {
                  !isReadOnly && showDelete &&
                  <td
                    role="button"
                    className="d-flex justify-content-center align-items-center folio-column"
                    onClick={() => onClickDeleteRow(i)}
                  >
                    <i className="fa-solid fa-minus"></i>
                  </td>
                }

                {
                  showForm &&
                  <td
                    role="button"
                    className="edit-row-button px-2"
                    onClick={() => {
                      setFormValue(row);
                      setIsFormModalShown(true);
                    }}
                  >
                    {l("Editar%GA002")}
                  </td>
                }

              </tr>
            ))
          }
        </tbody>

        {
          showAdd &&
          <tfoot>
            <tr>
              <td
                colSpan={columns.length + 2}
                className="add-row">
                <div className="w-100 text-center">
                  <button className="btn btn-sm btn-link w-100 text-center"
                    onClick={onAddRow}>
                    <span className="mr-1">+</span> {l("Agregar registro%CA012")}
                  </button>
                </div>
              </td>
            </tr>
          </tfoot>
        }

      </table>

      {isLoading &&
        <div
          id="loading-content"
          className="d-flex justify-content-center position-absolute w-100 h-100"
          colSpan={columns.length + 2}
        >
          <div>
            <Loading />
          </div>
        </div>
      }


      {
        isFilePreviewShown && <Modal
          width="800"
          height="680"
          onClose={() => {
            setSelectedFile(null);
            setIsFilePreviewShown(false);
          }}
          component={() => <FileViewer file={selectedFile} />}
        />
      }

    </div>
  );

}

export default TableDatagrid;